module.exports = __webpack_public_path__ + "img/kertas-nasi.a7505351.jpeg";